import { api } from '../../../services/Api';

export const getClientsService = async () => {
    return api.get("/api/clients/list")
}

export const registerClientService = async ( clientData ) => {
    return api.post("/api/clients/register", clientData)
}

export const editClientService = async (id, clientData) => {
    return api.put(`/api/clients/edit/${id}`, clientData)
}

export const deleteClientService = async ( id ) => {
    return api.delete(`/api/clients/delete/${id}`)
}
